import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section emoji="❓" eyebrow="FAQ" title="Frequently asked questions" className="bg-cream" data-id="element-79" data-mp="1cft2zqytkrv3">
      <div className="space-y-3" data-id="element-80" data-mp="2a176afexomwp">
        {faqs.map((faq, index) => {
        const isOpen = open === index;
        return <div key={faq.q} className="overflow-hidden rounded-2xl border border-navy/8 bg-white shadow-sm" data-id="element-81" data-mp="2512qkrlunw7j" data-mpi={index}>
              <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left" data-id="element-82" data-mp="1v5r9w3qvsex5">
                <span className="text-[14.5px] font-bold leading-snug text-navy sm:text-base" data-id="element-83" data-mp="1knqipi0yxi2f">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-teal-600 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-84" data-mp="1plry9sz6qz95" />
              </button>
              <AnimatePresence initial={false} data-id="element-85" data-mp="11wp98028244m">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: 'easeInOut'
            }} data-id="element-86" data-mp="16nyy2yfy53fg">
                    <p className="px-4 pb-4 text-[14px] leading-relaxed text-navy/70 sm:text-[15px]" data-id="element-87" data-mp="iyczod7ees8i">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>

      <div className="mx-auto mt-8 max-w-md" data-id="element-88" data-mp="2poq4z9ffx5il">
        <CTAButton label="All clear — I'm in" sublabel="Instant download · 7-day guarantee" data-id="element-89" data-mp="2kvn6cmvt35vj" />
      </div>
    </Section>;
}